import { useState, useRef, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import info from "../../info.jsonc";
const links: { name: string; link: string }[] = info.links;

interface Command {
  output: string | void;
  isError?: boolean;
}

export default function Term({ navLinks }: { navLinks: { path: string; label: string }[] }) {
  const [input, setInput] = useState("");
  const [history, setHistory] = useState<Command[]>([]);
  const inputRef = useRef<HTMLInputElement>(null);
  const bottomRef = useRef<HTMLDivElement>(null);
  const nav = useNavigate();
  const loc = useLocation();

  const bashPrompt = "$ theace@home "
  const helpMes = `Available commands:
  help      - Show this help message
  echo      - Echo the provided arguments
  date      - Show current date and time
  whoami    - Show current user
  clear     - Clear the terminal
  cd        - Change directory
  code      - Launch VSCode
  vim       - Launch vim
  ls        - List files `

  function writeToTerminal() {
    const mes = "help"
    setHistory([
      { output: bashPrompt + mes },
      { output: helpMes }
    ])
  }

  useEffect(() => {
    inputRef.current?.focus();
    writeToTerminal();
  }, []);

  useEffect(() => {
    document.getElementById(loc.hash.replace("#", ""))?.scrollIntoView({ behavior: "smooth" });
  }, [loc.hash])

  function cdTo(dir: string) {
    if (!dir) {
      nav("/")
      return
    }
    let t = dir.toLowerCase();
    if (t === "home") {
      nav("/")
      return;
    } else if (t === 'sefira') {
      nav(t)
      return
    }
    let found = false;
    navLinks.forEach(nl => {
      if ((nl.label.toLowerCase()) === t) {
        found = true;
      }
    });
    if (found) {
      nav("#" + t)
      console.log(t);

      return;
    } else {
      return "-bash: cd: " + dir + ": No such file or directory";;
    }
  }
  const paths = navLinks.map(nl => {
    return nl.path;
  })

  const commands: Record<string, (args: string[]) => string | void> = {
    help: () => helpMes,
    cd: (args) => cdTo(args?.[0] || "/"),
    echo: (args) => args.join(" "),
    date: () => new Date().toString(),
    whoami: () => "theace",
    code: () => {
      window.open(links.find(l => l.name === "code")?.link, "_blank")
      return
    },
    vim: () => {
      window.open(links.find(l => l.name === "vim")?.link, "_blank")
      return
    },
    ls: () => paths.join(" "),
    clear: () => {
      setHistory([]);
      return
    },
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = input.trim().toLowerCase();
    if (!trimmed) {
      setInput("");
      setHistory((prev) => [...prev, { output: bashPrompt }]);
      return;
    }


    const [cmd, ...args] = trimmed.split(" ");
    if (!cmd) {
      setInput("");
      return;
    }
    const output = commands[cmd] ? commands[cmd](args) : `command not found: ${cmd}`;
    setHistory((prev) => [
      ...prev,
      { output: history.length > 1 && trimmed !== 'clear' ? `${bashPrompt + trimmed}` : "" },
      { output, isError: !commands[cmd] },
    ]);
    setInput("");
  };

  return (
    <div
      className="w-full max-w-4xl"
      onClick={() => inputRef.current?.focus()}
    >
      {/* <ScroolToView /> */}
      <div className="bg-zinc-900 rounded-lg p-2 md:p-4 mx-auto font-mono text-sm w-full h-[40vh] md:h-[60vh] flex flex-col">
        <div className="flex items-center gap-2 mb-2 md:mb-4 border-b border-zinc-800 pb-2 shrink-0">
          <div className="w-3 h-3 rounded-full bg-red-500" />
          <div className="w-3 h-3 rounded-full bg-yellow-500" />
          <div className="w-3 h-3 rounded-full bg-green-500" />
          <span className="ml-2 text-zinc-500 text-xs">bash</span>
        </div>
        <div className="flex-1 overflow-hidden">
          {history.map((line, i) => (
            <div key={i} className={line.isError ? "text-red-400" : "text-zinc-300"}>
              <pre className="whitespace-pre-wrap font-mono">{line.output ? line.output : ""}</pre>
            </div>
          ))}
          <form onSubmit={handleSubmit} className="flex items-center gap-2">
            <span className="">{bashPrompt}</span>
            <input
              ref={inputRef}
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              className="flex-1 bg-transparent border-none outline-none text-zinc-300 font-mono"
              autoComplete="off"
            />
          </form>
          <div ref={bottomRef} />
        </div>
      </div>
    </div>
  );
}
